export default "__VITE_ASSET__BnepqGGx__"